import Swiper from "swiper";
/*------------------------------------------------------------------------------------------------------------*/
/* Filename: syndicate.page.ts                                                                                */
/* Description: This file is for manage all functionalities for the syndicate page                            */
/* Created: 24/Sep/2020                                                                                        */
/* Copyright (c) 2023 Lottosocial by Hatchster                                                                */
/*------------------------------------------------ -----------------------------------------------------------*/

import { AsyncPipe, NgClass, NgFor, NgIf, NgStyle, SlicePipe } from "@angular/common";
import { ChangeDetectorRef, Component, ElementRef, Inject, inject, NgZone, OnDestroy, OnInit, PLATFORM_ID, signal, ViewChild } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Data, Router, RouterLink } from "@angular/router";
import { Plugins } from "@capacitor/core";
import { AuthGamesService } from "@core/AuthServices/authGames/auth-games.service";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { AuthSyndicateService } from "@core/AuthServices/authSyndicate/auth-syndicate.service";
import { AuthService } from "@core/auth.service";
import { CelebrationAnimationService } from "@core/celebration-animation.service";
import { LoadingService } from "@core/loading.service";
import { UtilityService } from "@core/utility.service";
import { IonContent, IonicModule, IonInfiniteScroll, ModalController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Chart } from "chart.js";
import * as moment from "moment";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { BehaviorSubject, combineLatest, Observable, of, Subject, Subscription, timer } from "rxjs";
import { catchError, concatMap, filter, map, shareReplay, switchMap, take, takeUntil, tap } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { CountDownTimerAppComponent } from "src/app/components/count-down-timer-app/count-down-timer-app.component";
import { InboxMessageComponent } from "src/app/components/inbox-message/inbox-message.component";
import { PickGoldRingsComponent } from "src/app/components/pick-gold-rings/pick-gold-rings.component";
import { SafeHtmlPipe } from "src/app/pipe/safehtmlpipe";
import { SyndicatePaymentService } from "src/app/services/SyndicateService/syndicate-payment.service";
import { SyndicateRootService } from "src/app/services/SyndicateService/syndicate-root.service";
import { AnimationService } from "src/app/services/animation.service";
import { CashPurchaseService } from "src/app/services/cash-purchase.service";
import { ChatbotWidgetService } from "src/app/services/chatbotwidget/chatbot-widget.service";
import { CommonService } from "src/app/services/common/common.service";
import { CustomModalTransitionService } from "src/app/services/custom-modal-transition.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { HomeDataService } from "src/app/services/home-data.service";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { LswTokenService } from "src/app/services/lsw-token.service";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { NotificationManagerService } from "src/app/services/notification-manager.service";
import { NotificationsService } from "src/app/services/notifications.service";
import { OrientationService } from "src/app/services/orientation.service";
import { PaymentService } from "src/app/services/payment.service";
import { RemoteConfigForpsService } from "src/app/services/remote-config-forps.service";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { InProgressAnimationComponent } from "../../components/in-progress-animation/in-progress-animation.component";
import { AddHomeScreenBannerComponent } from "../../components/add-home-screen-banner/add-home-screen-banner.component";
import { shouldShowAddHomeScreenBanner } from "../../components/add-home-screen-banner/add-home-screen.helpers";
import { PushNotificationBannerComponent } from "../../components/push-notification-banner/push-notification-banner.component";
import { TopHeaderComponent } from "../../components/top-header/top-header.component";
import { GamesRepositoryService } from "../games/games-repository.service";
import { HomeRepositoryService } from "../home/home-repository.service";
import { PrivateSyndicateRepositoryService } from "../private-syndicate/private-syndicate.repository.service";
import { StoreJackpotRepositoryService } from "../store/store-jackpot.service";
import { StoreRepositoryService } from "../store/store-repository.service";
import { StoreJackpotTriggerDataService } from "../store/services/store-jackpot-trigger-data.service";
import { TabRepositoryService } from "../tabs/tab-repository.service";
import { JackpotInfoPopupComponent } from "./jackpot-info-popup/jackpot-info-popup.component";
import { LuckySliderStepperComponent } from "./lucky-slider-stepper/lucky-slider-stepper.component";
import { SyndicateCardComponent } from "./syndicate-card/syndicate-card.component";
import { SyndicateGoldringComponent } from "./syndicate-goldring/syndicate-goldring.component";
import { SyndicateJackpotPopupComponent } from "./syndicate-jackpot-popup/syndicate-jackpot-popup.component";
import { SyndicateJackpotTriggerComponent } from "./syndicate-jackpot-trigger/syndicate-jackpot-trigger.component";
import { SyndicateNotificationService } from "./syndicate-notification.service";
import { VoucherNotificationService } from "src/app/components/vouchers/voucher-notification.service";
import { SyndicatePreviousChecksComponent } from "./syndicate-previous-checks/syndicate-previous-checks.component";
import { SyndicateRepositoryService } from "./syndicate-repository.service";
import { SyndicateSettingComponent } from "./syndicate-setting/syndicate-setting.component";
import { SyndicateWidgetsFacadeService } from "./syndicate-widgets-facade";
import { SyndicateUIHelperService } from "./syndicate-ui-helper.service";
import { CheckWinningsFlowService } from "../check-winnings/check-winnings-flow.service";
import { GameDatasService } from "../games/services/game-data.service";

const { Browser } = Plugins;

@Component({
  selector: "app-syndicate",
  templateUrl: "./syndicate.page.html",
  styleUrls: ["./syndicate.page.scss"],
  standalone: true,
  imports: [
    LottieComponent,
    TopHeaderComponent,
    NgIf,
    IonicModule,
    NgClass,
    SwiperModule,
    SyndicatePreviousChecksComponent,
    NgStyle,
    SyndicateGoldringComponent,
    SyndicateJackpotTriggerComponent,
    NgFor,
    RouterLink,
    PushNotificationBannerComponent,
    AddHomeScreenBannerComponent,
    InProgressAnimationComponent,
    AsyncPipe,
    SlicePipe,
    TranslatePipe,
    SyndicateCardComponent,
    CountDownTimerAppComponent,
    SafeHtmlPipe
  ],
  providers: [SyndicateWidgetsFacadeService, SyndicateNotificationService, SyndicateUIHelperService]
})
export class SyndicatePage implements OnInit, OnDestroy {
  private ngZone = inject(NgZone);
  private changeDetectorRef = inject(ChangeDetectorRef);
  public voucherNotificationService = inject(VoucherNotificationService);

  showWidget: boolean = false;
  private widgetSubscription: Subscription;
  private swiperSubscription: Subscription;
  private hideTimeout: any;
  private inboxAutoShowSubscription: Subscription;
  @ViewChild("lineCanvas", { static: false }) private lineCanvas: ElementRef;
  @ViewChild("swiperSliders", { static: false }) swiperSliders?: SwiperComponent;
  isVoucherClaimedSignal = signal<boolean>(false);
  swiperInstance: Swiper;
  showAvailableLn: Boolean;
  lineChart: any;
  translatedToastMsg: any;
  isToggled: boolean = true;
  synhighlightedColor: string = "#ffffff";
  syndicatePageOffer$ = new BehaviorSubject(null);
  syndicateDetails$ = new BehaviorSubject(null);
  private unsubscribe$ = new Subject<void>();
  storeDiscountDetails: Data;
  managedSyndicateDetails$ = new BehaviorSubject(null);
  jackpotTriggers$ = new BehaviorSubject(null);
  checkWinnings$ = this.syndicateService?.previousCheck$ || of([]);
  checkWinningsInFlight$ = this.checkWinningsFlowService.isInFlight$;
  progressBar = 0;
  sub: any;
  timer$: any;
  slides: Swiper;
  intervals: any;
  time: number;
  lotteryData;
  showToolTip$ = new BehaviorSubject(true);
  syndicateCount: number = 0;
  showText: boolean = false;
  isAutoShowView: boolean;
  triggerActiveCount: any;
  privateSyndicateTicket$ = this.privateSyndicateService?.getPrivateSyndicateTickets() || of([]);
  autoplay: boolean;
  LnRemainingBalance: number;
  LnUsedBalance: number;
  LnRemainingTxt: string;
  LnUsedTxt: string;
  public win_more_expire: boolean;
  public feedBackTypeFormViewed: boolean;
  public typeformUrlId: string;
  public notificationData: Data;
  public showPointsNotification = false;
  public lottryDescription$ = new BehaviorSubject("");
  public syndicateData: Data;
  private userInboxSubscription: Subscription;
  private countdownSub: Subscription;
  destroy$ = new Subject<void>();
  show$ = combineLatest(this.authService?.userDetails$ || of(null), this.showToolTip$).pipe(
    map(([user, toolTip]: any) => {
      if (user && user?.onboard_state === "awareness" && toolTip) {
        return true;
      }
      return false;
    })
  );
  public countdownSeconds: number | null;
  updateAnimationSubject = new Subject<{ location_id: string; delayTime: number }>();
  private animationDestroy$ = new Subject<void>();
  firstSyndicateDotOptions: AnimationOptions = { path: "" };
  firstSyndicateCTAOptions: AnimationOptions = { path: "" };
  previousCheckLinkOptions: AnimationOptions = { path: "" };
  jackpotOptions: AnimationOptions = { path: "" };
  luckyNumberOptions: AnimationOptions = { path: "" };
  firstSyndicateDotStatus: boolean;
  firstSyndicateCTAStatus: boolean;
  previousCheckLinkStatus: boolean;
  luckyNumberStatus: boolean;
  jackpotStatus: boolean;

  firstSyndicateCTADuration: number;
  firstSyndicateDotDuration: number;
  previousCheckLinkDuration: number;
  luckyNumberDuration: number;
  jackpotDuration: number;

  isPsCreateHide$ = this.remoteConfigForpservice?.isCreateHide$ || of(false);

  inlineNotificationDetails: Data;
  syndicateFullDetails: Data;
  // This method is used to get all syndicate data needed for th page.
  syndicatePageData$ = this.syndicateDataService
    ? this.syndicateDataService?.getSyndicatePageData()?.pipe(
      map((syndicateData) => {
        this.syndicateData = syndicateData;
        this.notificationService.validateNotifications(syndicateData);

        if (!syndicateData || !syndicateData?.syndicate_list) {
          // Handle null syndicateData
          this.loadingStart = false;
          this.showView = false;
          return [];
        }
        const syndicate_list = syndicateData?.syndicate_list?.syndicate_cards;
        this.loadingStart = true;
        this.showView = true;
        // this.syndicateLoaded = [];
        if (!syndicate_list || syndicate_list?.length === 0) {
          this.loadingStart = false;
          this.showView = false;
          return [];
        }
        syndicate_list?.map((d) => (d["expanded"] = false));
        this.loadingStart = false;
        this.showView = false;

        setTimeout(() => {
          if (syndicate_list?.[0]) {
            syndicate_list[0]["expanded"] = true;
          }
        }, 3000);
        let syndicateLoadedData = syndicate_list; // variable contain syndicateLoaded data
        // set win more end value as true / false
        syndicateLoadedData?.forEach((res: Data) => {
          if (res?.win_more_promise_details?.end_date) {
            const endDate = res?.win_more_promise_details?.end_date?.toDate()?.getTime(); //end date
            const currentDate = new Date().getTime(); //current date
            const TimeDifference = endDate - currentDate; // Get Time Difference
            const seconds = Math.floor((TimeDifference % (1000 * 60)) / 1000); //Get Seconds
            // set win more end value as true / false
            this.win_more_expire = seconds >= 0 ? (res.win_more_end = false) : (res.win_more_end = true);
          } else {
            res.win_more_end = true;
          }
        });

        // This method has been ustilized to get the latest syndicate data and match it with the image url
        syndicateLoadedData.filter((res: Data) => {
          const url = res?.syndicate_image_url;
          const regex = /rapidfire_header/;
          const match = url?.match(regex);
          if (match) res.isRapidfire = match ? true : false;
        });

        this.syndicateLoaded = syndicateLoadedData;
        this.syndicateCount = this.syndicateLoaded?.length;
        this.syndicateUIHelper.updateGoldRingIcon(this.syndicateLoaded,this.destroy$, this.showGoldRingMiniWidget, this.showGoldExpandWidget, this.showGoldRingAvailableSyndicateWidget);
        this.syndicateUIHelper.updateLuckyNumberIcon(this.syndicateLoaded,this.destroy$, this.showMiniWidget, this.showExpandWidget, this.showGoldRingAvailableSyndicateWidget);
        this.cdRf.detectChanges();
        this.syndicateUIHelper.pendingStatusIcon(this.syndicateLoaded, this.destroy$);
        this.clearSyndicatePendingIfNeeded();
        return syndicate_list;
      }),
      catchError(() => { // Add this catchError operator
        this.loadingStart = false;
        this.showView = false;
        this.syndicateLoaded = [];
        this.cdRf.detectChanges();
        return of([]); // Provide a fallback empty array for the stream
      }),
      tap((data: any) => {
        this.showView = false;
        if (data && !this.showView) {
          this.showView = true;
        }
      })
    ) : of([]);

  // This function is used to get all lotteries and jackpot values
  // lotteryData$ = combineLatest([this.storeService.lotteries$, this.storeService.jackpots$])?.subscribe(
  //   (data) => {
  //     this.lotteryData = data;
  //   },
  //   (err) => {
  //     return err;
  //   }
  // );

  // This function is used to get all jackpot triggers
  jackpotTrigger$ = this.jackpotTriggerDataService?.jackpotTrigger$.pipe(
    map((res: Data) => {
      if (!res) return [];
      let activeJackpotArr = [];
      const activeJackpots = res?.activeJackpots;

      this.triggerActiveCount = res?.totalJackpots;
      let displayOrder = [
        "EuroMillions",
        "Powerball",
        "Lotto",
        "LottoMax",
        "SuperEnalotto",
        "FrenchLotto",
        "Eurojackpot",
        "LaPrimitiva",
      ];
      displayOrder?.map((objOrder) => {
        const orderedActiveJackpots = activeJackpots?.find(
          (activeJackpot) => activeJackpot?.jackpot_name?.toLowerCase() === objOrder?.toLowerCase()
        );
        if (orderedActiveJackpots) activeJackpotArr.push(orderedActiveJackpots);
      });
      const orderedJackpots = activeJackpotArr?.length > 0 ? [...activeJackpotArr] : [];
      //const orderedJackpots = inactiveJackpotArr.concat(activeJackpotArr);
      // Removed callSwiper() call from here to prevent multiple subscriptions
      return orderedJackpots ? orderedJackpots : activeJackpots;
    }),
    shareReplay(1)
  );


  isWinning$ = this.syndicateService?.isWinning$ || of(false);
  @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;
  @ViewChild("pageTop") pageTop: IonContent;
  loadingStart = true;
  syndicateLoaded: any = [];
  isWinningsAvailable = true;
  bottomButtonVisibility = false;
  backgroundNoScroll = true;
  isChatClicked: boolean;
  showView;
  showAllMiniWidget: boolean = true;
  showMiniWidget: boolean = false;
  showExpandWidget: boolean = false;
  showWidgetToolTip: boolean = false;
  showAvailableSyndicateWidget: boolean = false;
  showJackpotMiniWidget: boolean = true;
  showJackpotExpandWidget: boolean = false;
  showPreviousMiniWidget: boolean = true;
  showPreviousExpandWidget: boolean = false;
  showGoldRingMiniWidget: boolean = true;
  widgetDetails: any = {};
  syndicateToolTip = this.homeRepositoryService?.toolTipText$;
  userBalanceDetails$ = this.authService?.userCurrentBalance$ || of([]);
  luckyNumbersWidget: any;
  toolTipMsg: any;
  lnWidgetdescription: any;
  syndicateColor = "#ffffff";
  luckyNumberIcon: any;
  jackpotWidgetTranslatedData: any;
  syndicatePageData: any;
  preferredCurrency: string = CommonVariable.preferredCurrency;
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  CurrentCheckWinningsStats: any;
  CheckWinningsStatsMessage: any;
  showPreviousCheck: any = false;
  showPreviousCheckCouch: any = false;
  languageCode: string = CommonVariable.preferredLanguage;
  luckyNumberWidget: any;
  availableRemainingLn: string;
  noRemainingLn: string;
  highlightAvailableLn: string;
  highlightLnTitle: string;
  showGoldRingToolTip: boolean = false;
  showGoldRingAvailableSyndicateWidget = false;
  showGoldExpandWidget = false;
  goldRingWidgetDetails: Data = {};
  goldRingsWidget: Data;
  goldRingToolTipMsg: string;
  grWidgetdescription: string;
  goldRingWidget: Data;
  showWidgetsData: Data;
  checkSwiperValue = false;

  slideOpts: SwiperOptions = {
    speed: 400,
    slidesPerView: 2.1,
    slidesPerGroup: 2.1,
    spaceBetween: 5,
    slideToClickedSlide: false,
    loop: false,
  };
  SliderOptions: SwiperOptions = {
    centeredSlides: true,
    slidesPerView: 1.1,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 1000,
    loop: false, // Initial setting
  };
  options: AnimationOptions = {
    path: "https://assets8.lottiefiles.com/packages/lf20_k0qv8hhf.json",
  };
  syndicatePending: boolean = false;
  private syndicatePendingClearInFlight = false;
  public showBtn: string;
  public extras: string;
  public interval: any;
  setIntervalNumber: number;
  cardLimit = 5;
  speed: number;
  public syndicatePaymentStatus: string;
  public isShown: boolean;
  public syndicateID: string;
  public banner_status: boolean;
  toastShown = false;
  userId: string;
  jackpotTriggerData = {};
  reamainingJackpotTriggers = 0;
  constructor(
    private ChatbotWidgetService: ChatbotWidgetService,
    private firestore: Firestore,
    private modalCtrl: ModalController,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
    public syndicateDataService: SyndicateDataService,
    private cdRf: ChangeDetectorRef,
    private tabService: TabRepositoryService,
    private gameDatasService : GameDatasService,
    private authService: AuthService,
    private privateSyndicateService: PrivateSyndicateRepositoryService,
    private storeService: StoreRepositoryService,
    private jackpotTriggerDataService: StoreJackpotTriggerDataService,
    private homeRepositoryService: HomeRepositoryService,
    public translate: TranslateService,
    private remoteConfigForpservice: RemoteConfigForpsService,
    private lswTokenService: LswTokenService,
    private matDialog: MatDialog,
    private luckyNumberService: LuckyNumberService,
    private route: ActivatedRoute,
    private jackpotTriggerService: JackpotTriggersService,
    private loadingService: LoadingService,
    private GTMSegment: GTMSegmentService,
    private mixpanelService: MixpanelService,
    private cas: CustomModalTransitionService,
    private orientationService: OrientationService,
    private celebrationAnimationService: CelebrationAnimationService,
    private gameRepoService: GamesRepositoryService,
    private AuthGamesService: AuthGamesService,
    private AuthPartialRegService: AuthPartialRegService,
    private AuthSyndicateService: AuthSyndicateService,
    private animationService: AnimationService,
    private notificationManagerService: NotificationManagerService,
    private syndicateRootService: SyndicateRootService,
    private syndicatePaymentService: SyndicatePaymentService,
    private homeDataService: HomeDataService,
    private cashPurchaseService: CashPurchaseService,
    private notificationsService: NotificationsService,
    private commonService: CommonService,
    private storeJackpotService: StoreJackpotRepositoryService,
    private syndicateUIHelper: SyndicateUIHelperService,
    private widgetsFacade: SyndicateWidgetsFacadeService,
    private notificationService: SyndicateNotificationService,
    private checkWinningsFlowService: CheckWinningsFlowService,
    private paymentService: PaymentService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.homeDataService.initializeHomePage();
    this.feedBackTypeFormViewed = false; // set Default value
    this.setIntervalNumber = 2000;
    this.speed = 500;
    this.time = 3000;
    this.autoplay = true;
    this.loadingService.dismiss();
    // setupSyndicateOnboarding function was commented out because it was not required now will enable it when required
    // this.setupSyndicateOnboarding();
    // This method is used to get user details such as currency, language
    try {
      this.authService?.userDetails$
        ?.pipe(
          takeUntil(this.unsubscribe$),
          catchError(() => of(null)),
          switchMap((user: any) => {
            if (!user) return of(null);
            const selectedLanguage = this.languageCode ? this.languageCode : CommonVariable.preferredLanguage;
            this.languageCode = selectedLanguage;
            translate.use(selectedLanguage);
            this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
            return this.authService?.getCurrencyList$?.pipe(
              takeUntil(this.unsubscribe$),
              catchError(() => of({ details: [] }))
            ) ?? of({ details: [] });
          })
        )
        .subscribe((data: Data) => {
          if (!data) return;
          const CurrencyDetails = data?.details?.find(
            (x: Data) => x?.currency_code === this.preferredCurrency
          );
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });
      this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
        this.translatedToastMsg = msg?.static_messages_pwa;
      });
    } catch (e) {
      return e;
    }
    // This method has been used to get syndicate payment status
    this.widgetsFacade.getStoreAndSyndicateDetails();
    this.getJackpotTriggerData();
  }

  getJackpotTriggerData() {
    this.storeService.storeData$.pipe(
      map((data: Data) => data?.jackpot_triggers ?? []),
      takeUntil(this.unsubscribe$)
    ).subscribe((data) => {
      this.jackpotTriggerData = data;
      const desc = data?.description;
      if (!desc) return;
      const match = desc.match(/\d+/);

      if (match) {
        this.reamainingJackpotTriggers = parseInt(match[0], 10);
      }
    });
  }

  // This method is used to get set private syndicate details
  setPSData(allSyndicateData, index) {
    try {
      if (allSyndicateData[2]?.length === index + 1) {
        this.syndicateDetails$.next(allSyndicateData[2]);
      }
    } catch (e) {
      return e;
    }
  }
  ///
  openAnimation() {
    // this.router.navigateByUrl("/lottieplayer").then(() => {
    // }).catch((err) => {
    // });
  }

  // This function is used to fetch the product selected numbers
  async eachProductSelectedNumbers(productObj) {
    return new Promise((resolve, reject) => {
      let hasSelectedNumber = false;
      try {
        let loopCount: number = 0;
        if (productObj?.products) {
          try {
            var productLength = productObj?.products?.length;
            if (productLength > 0) {
              productObj?.products?.forEach((eachProduct: any) => {
                hasSelectedNumber = false;
                if (eachProduct?.selected_numbers) {
                  hasSelectedNumber = true;
                  resolve(hasSelectedNumber);
                }
                loopCount++;
                if (loopCount >= productLength) {
                  resolve(hasSelectedNumber);
                }
              });
            } else {
              reject(hasSelectedNumber);
            }
          } catch (e) {
            reject(hasSelectedNumber);
            return e;
          }
        } else {
          reject(hasSelectedNumber);
        }
      } catch (error) {
        reject(hasSelectedNumber);
        return error;
      }
    });
  }

  // This method is used for update lucky number icon

  // This method is used to enable mini widgets
  enableMiniOnly() {
    this.showMiniWidget = true;
    if (!this.showJackpotExpandWidget && !this.showPreviousExpandWidget && !this.showGoldExpandWidget)
      this.showAllMiniWidget = true;
    this.showExpandWidget = false;
    this.showAvailableSyndicateWidget = false;
  }

  enableGoldRingMiniOnly() {
    this.showGoldRingMiniWidget = true;
    if (!this.showJackpotExpandWidget && !this.showPreviousExpandWidget && !this.showExpandWidget)
      this.showAllMiniWidget = true;
    this.showGoldExpandWidget = false;
    this.showGoldRingAvailableSyndicateWidget = false;
  }

  // This method is used to enable expanded widgets
  enableExpandOnly() {
    this.showExpandWidget = true;
    this.showMiniWidget = false;
    this.showAllMiniWidget = false;
    this.showAvailableSyndicateWidget = false;
  }

  // This method is used to enable available syndicate widgets
  enableAvailableSyndicateOnly() {
    this.showAvailableSyndicateWidget = true;
    this.showMiniWidget = false;
    this.showAllMiniWidget = false;
    this.showExpandWidget = false;
  }

  enableGoldRingAvailableSyndicateOnly() {
    this.showGoldRingAvailableSyndicateWidget = true;
    this.showGoldRingMiniWidget = false;
    this.showAllMiniWidget = false;
    this.showGoldExpandWidget = false;
  }

  // This method is to show all mini widgets
  // Now uses facade - keeping for backward compatibility
  async showMiniWidgets() {
    try {
      // Widget data is now managed by the facade
      // This method is kept for backward compatibility with template
      this.enableMiniOnly();
    } catch (e) {
      return e;
    }
  }


  async showGoldRingsMiniWidget(): Promise<void> {
    const userId = this.userId;

    // Call the facade service to handle widget display
    await this.widgetsFacade.showGoldRingsMiniWidget(
      userId,
      this.changeDetectorRef,
      [], // No longer needed - facade handles cleanup
      (goldRingWidget: any) => {
        // Callback to update component properties and call component methods
        this.goldRingWidgetDetails = goldRingWidget || {};
        this.enableGoldRingMiniOnly();
        // Data is now handled by facade subscription
      }
    );
  }



  // This method is for get tooltip content for lucky number widget
  // Now uses proper RxJS with takeUntil

  grToolTip() {
    this.showGoldRingToolTip = false;
    localStorage.setItem("hasVisitedGR", "true");
  }


  // This method is used to show expand view of lucky number widget
  showExpandView() {
    if (this.showWidgetToolTip) this.router.navigate(["mainTabs/tabs/syndicate"], {});
    this.enableExpandOnly();
    this.showWidgetToolTip = false;
    this.showToolTip$.next(false);
    if (this.LnRemainingBalance === 0) {
      this.lnWidgetdescription = this.noRemainingLn;
    } else if (this.LnRemainingBalance > 0) {
      this.lnWidgetdescription = this.availableRemainingLn;
    } else {
      return false;
    }
  }

  //Initiate line chart method after view initialized
  ngAfterViewInit(): void {
    if (this.lineChart instanceof Chart) this.lineChart?.destroy();
    this.syndicateUIHelper.lineChartMethod(this.lineCanvas, this.CurrentCheckWinningsStats);
  }


  handleInlineNotification(notificationDetails: Data) {

    this.notificationService.handleInlineNotification(notificationDetails);

  }

  isPushNotification(): boolean {
    const details = this.notificationService.inlineNotificationDetails;
    const id = details?.notification_id?.id || details?.id;
    // Match push-notification-banner detection so Syndicate never falls through to
    // the generic inline slot (which always renders claim line_1).
    if (id === "push_notification") {
      return true;
    }
    const actionDetails = details?.action?.details?.toLowerCase?.() || "";
    return (
      actionDetails === "enable_push_notifications" ||
      actionDetails === "enable push notifications"
    );
  }

  isAddHomeScreen(): boolean {
    const actionDetails = this.notificationService.inlineNotificationDetails?.action?.details?.toLowerCase();
    return shouldShowAddHomeScreenBanner(
      actionDetails,
      CommonVariable?.device?.operatingSystem,
      UtilityService.isAppInstalledOnHomePage()
    );
  }
  // This is showing line chart for all winnings/checks

  showPreviousExpandView(event) {
    this.GTMSegment.HotJarEvent("click_previous_check");
    event.stopPropagation();
    if (this.lineChart instanceof Chart) this.lineChart.destroy();
    this.syndicateUIHelper.lineChartMethod(this.lineCanvas, this.CurrentCheckWinningsStats);
    this.showPreviousMiniWidget = false;
    this.showAllMiniWidget = false;
    this.showPreviousExpandWidget = true;

    if (this.showPreviousCheckCouch === true) {
      this.syndicateService?.updatePreviousCheckNodes("previous_widget_couch");
      this.showPreviousCheckCouch = false;
    }
  }

  // Close previous check expand widget
  closePreviousExpandWidget() {
    this.showPreviousMiniWidget = true;
    this.showAllMiniWidget = true;
    this.showPreviousExpandWidget = false;
  }

  showGoldExpandView() {
    this.grToolTip();
    this.showGoldRingMiniWidget = false;
    this.showAllMiniWidget = false;
    this.showGoldExpandWidget = true;
    if (this.goldRingWidgetDetails?.remaining === 0) {
      this.grWidgetdescription = this.goldRingWidget?.no_remaining_gr;
    } else if (this.goldRingWidgetDetails?.remaining > 0) {
      this.grWidgetdescription = this.goldRingWidget?.available_remaining_gr;
    } else {
      return false;
    }
  }

  // This method is used to close jackpot expand widget
  closeGoldExpandWidget() {
    this.enableGoldRingMiniOnly();
    if (this.showGoldRingToolTip) this.grToolTip();
  }

  picktings_open() {
    this.closeGoldExpandWidget();
    this.showGoldRingsMiniWidget();
    this.bottomSheet.open(PickGoldRingsComponent, {
      panelClass: "pick-gold-rings",
      hasBackdrop: true,
    });
  }

  // this method is for show jackpot mini widget expanded view
  showJackpotExpandView(event) {
    event.stopPropagation();
    this.showJackpotMiniWidget = false;
    this.showAllMiniWidget = false;
    this.showJackpotExpandWidget = true;
  }

  // This method is used to close jackpot expand widget
  closeJackpotExpandWidget() {
    this.showJackpotExpandWidget = false;
    this.showJackpotMiniWidget = true;
    this.showAllMiniWidget = true;
  }

  // This method is to show lucky number slider dialog
  sliderShow(event) {
    event.stopPropagation();
    // this.router.navigate(["/lucky-slider-stepper"]);
    this.matDialog.open(LuckySliderStepperComponent, {
      width: "100%",
      height: "100vh",
      panelClass: "onboarding-slider-pages",
    });
  }

  // This method is used to shrink the widget
  shrinkWidget() {
    this.showWidgetToolTip = false;
    this.enableMiniOnly();
  }

  // This method is to check and enable available syndicate widget
  availableSyndicates() {
    this.synhighlightedColor = "#E0FDF6";
    this.enableAvailableSyndicateOnly();
    this.lnWidgetdescription = this.highlightAvailableLn;
  }

  goldRingsAvailableSyndicates() {
    this.enableGoldRingAvailableSyndicateOnly();
    this.grWidgetdescription = this.goldRingWidget?.highlight_available_gr;
  }

  // This method is to close all expanded widget
  closeExpandWidget() {
    this.synhighlightedColor = "#ffffff";
    this.enableMiniOnly();
  }

  /** Clears Firestore syndicate_pending once the list has active syndicates. */
  private clearSyndicatePendingIfNeeded(): void {
    if (!this.syndicatePending || !this.syndicateLoaded?.length || this.syndicatePendingClearInFlight) {
      return;
    }
    this.syndicatePendingClearInFlight = true;
    this.paymentService
      .clearSyndicatePending()
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.syndicatePendingClearInFlight = false;
        },
        error: (error) => {
          this.syndicatePendingClearInFlight = false;
          this.authService.errorHandlerLogs("clearSyndicatePending:", error);
        },
      });
  }

  ionViewWillEnter() {
    this.toastShown = false;
    this.isAutoShowView = false;
    this.celebrationAnimationService.trackCelebrations();
    this.notificationService.showInboxMessage();
  }

  ngOnDestroy() {
    // Firestore listeners are now managed by the facade and notification service
    // They will be cleaned up when their ngOnDestroy is called
    try {
      this.widgetsFacade.teardown();
    } catch (error) {
      // Suppress unsubscription errors to prevent UnsubscriptionError propagation
      // These can occur when nested Firestore listeners clean up during destruction
    }
    
    try {
      this.notificationService.teardown();
    } catch (error) {
      // Suppress unsubscription errors
    }
    
    try {
      this.inboxAutoShowSubscription?.unsubscribe();
    } catch (error) {
      // Suppress unsubscription errors
    }

    this.unsubscribe$?.next();
    this.unsubscribe$?.complete();
    try {
      if (this.widgetSubscription) {
        this.widgetSubscription?.unsubscribe();
      }
    } catch (error) {
      // Suppress unsubscription errors
    }

    try {
      // Unsubscribe from swiper subscription to prevent memory leaks
      if (this.swiperSubscription) {
        this.swiperSubscription?.unsubscribe();
      }
    } catch (error) {
      // Suppress unsubscription errors
    }

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    try {
      if (this.animationDestroy$) {
        this.animationDestroy$.next();
        this.animationDestroy$.complete();
      }
    } catch (error) {
      // Suppress completion errors
    }

    try {
      // Handle memory leak of countdown subscription
      if (this.countdownSub) {
        this.countdownSub?.unsubscribe();
      }
    } catch (error) {
      // Suppress unsubscription errors
    }

    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.intervals) {
      clearInterval(this.intervals);
    }

    try {
      // Stop autoplay for swiperInstance to prevent orphaned callbacks
      if (this.swiperInstance?.autoplay) {
        this.swiperInstance.autoplay.stop();
      }
    } catch (error) {
      // Suppress errors if autoplay is not available
    }

    try {
      // Stop autoplay for slides to prevent orphaned callbacks
      if (this.slides?.autoplay) {
        this.slides.autoplay.stop();
      }
    } catch (error) {
      // Suppress errors if autoplay is not available
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  openChatBot() {
    this.ChatbotWidgetService.openChatBot();
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    this.ChatbotWidgetService.setWidgetVisibility(true);
    this.hideTimeout = setTimeout(() => {
      this.ChatbotWidgetService.setWidgetVisibility(false);
    }, 300000);
  }
  callSwiper() {
    // Unsubscribe from any existing subscription to prevent memory leaks and race conditions
    if (this.swiperSubscription) {
      this.swiperSubscription.unsubscribe();
    }

    this.swiperSubscription = this.jackpotTrigger$?.subscribe((jackpotTrigger) => {
      if (Array.isArray(jackpotTrigger) && jackpotTrigger.length > 1) {
        this.checkSwiperValue = true;
      } else {
        this.checkSwiperValue = false;
      }
      // Update Swiper options dynamically with proper null/undefined checks
      // Ensure params and params.autoplay are defined before accessing them
      if (this.swiperInstance?.params && this.swiperInstance?.params?.autoplay !== undefined) {
        this.swiperInstance.params.loop = this.checkSwiperValue;
        this.swiperInstance.update(); // Reinitialize swiper to apply the updated options
      }
      if (this.slides?.params && this.slides?.params?.autoplay !== undefined) {
        this.slides.params.loop = this.checkSwiperValue;
        this.slides.update(); // Reinitialize swiper to apply the updated options
      }
    });
  }
  async ngOnInit() {
    this.notificationService.feedBackDismiss();
    await this.authService
      ?.getUid("SyndicatePage")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });

    // Initialize new services
    this.widgetsFacade.initialise(this.userId, this.languageCode);
    this.notificationService.initialise(this.userId, this.syndicateID);

    // Subscribe to facade observables
    this.widgetsFacade.goldRingData$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      this.goldRingWidgetDetails = data.details;
      this.LnRemainingBalance = data.remaining;
      this.LnUsedBalance = data.used;
    });

    this.widgetsFacade.luckyNumberData$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      this.widgetDetails = data.details;
      this.LnRemainingBalance = data.remaining;
      this.LnUsedBalance = data.used;
    });

    this.widgetsFacade.jackpotData$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      this.jackpotTriggers$.next(data.triggers);
    });

    this.widgetsFacade.previousChecks$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      this.CurrentCheckWinningsStats = data.stats;
      this.CheckWinningsStatsMessage = data.message;
      this.showPreviousCheckCouch = data.showCouch;
    });

    // Re-resolve inline banner copy when settings language changes (main_pages is flattened).
    this.authService?.selectedlanguage$?.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (l) => {
        const lang = l ?? CommonVariable.preferredLanguage;
        this.languageCode = lang;
        this.translate.use(lang);
        void this.notificationService.resolveInlineContentForLanguage(lang);
      },
      error: (err) => err,
    });

    // Subscribe to notification service observables
    this.notificationService.notification$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(notification => {
      this.inlineNotificationDetails = notification?.details || {};
      this.changeDetectorRef.markForCheck();
    });

    this.notificationService.countdown$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(countdown => {
      this.countdownSeconds = countdown?.seconds || null;
      this.changeDetectorRef.markForCheck();
    });

    this.notificationService.shouldShowInbox$.pipe(
      takeUntil(this.unsubscribe$),
      filter(show => show),
      take(1)
    ).subscribe(() => {
      this.notificationService.showInboxMessage();
    });
    this.callSwiper();
    this.widgetSubscription = this.ChatbotWidgetService?.widgetVisibility$?.subscribe((visible) => {
      this.showWidget = visible;
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      if (visible) {
        this.hideTimeout = setTimeout(() => {
          this.ChatbotWidgetService.setWidgetVisibility(false);
        }, 600000);
      }
    });
    this.AuthPartialRegService?.userInlineNotification()?.subscribe((notifications) => {
      // Check if notifications is truthy and has length
      if (notifications && notifications.length > 0) {
        // Iterate through each notification
        notifications?.forEach((notification) => {
          // Check if the "action" details include a Typeform URL
          if (notification?.action?.type === "Powerball lines") {
            // If found, you can store or process the notification here
            // Update the "viewed" node
            this.notificationData = notification;
            this.showPointsNotification = true;
            this.feedBackTypeFormViewed = notification?.viewed;
          }
        });
      }
    });

    try {
      combineLatest([this.storeService?.lotteries$ || of(null), this.storeJackpotService?.jackpots$ || of(null)])?.subscribe(
        (data) => {
          this.lotteryData = data;
        },
        (err) => {
          return err;
        }
      );
      // This method is to get syndicate pending status for the user and display pending animation
      this.syndicateService?.getSyndicatePending()
        ?.pipe(
          takeUntil(this.unsubscribe$),
          catchError(() => {
            return of(null); // Return fallback or null to avoid breaking the flow
          })
        )
        .subscribe((SyndicatePending: Data) => {
          this.syndicatePending = !!(SyndicatePending && SyndicatePending?.syndicate_pending === true);
          this.clearSyndicatePendingIfNeeded();
        });


      // This method is to get the check winnings stats to display in previous check mini widget
      this.syndicateService
        ?.getCheckWinningsStatsMessage()
        ?.pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (getCheckWinningsStatsMessage: any) => {
            if (getCheckWinningsStatsMessage) {
              this.CheckWinningsStatsMessage = getCheckWinningsStatsMessage;
            }
          },
          (err) => {
            return err;
          }
        );

      // This method is to get the current check winnings stats to display in previous check mini widget
      this.syndicateService
        ?.getCurrentCheckWinningsStats()
        ?.pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (getCurrentCheckWinningsStats: any) => {
            if (getCurrentCheckWinningsStats) {
              this.CurrentCheckWinningsStats = getCurrentCheckWinningsStats;
            }
          },
          (err) => {
            return err;
          }
        );

      this.storeService
        ?.jackpotActivatedCount$
        ?.pipe(takeUntil(this.unsubscribe$))
        .subscribe((count) => {
          this.triggerActiveCount = count;
        });
    } catch (e) {
      return e;
    }
    try {
      this.authService?.userDetails$?.pipe(
        takeUntil(this.unsubscribe$),
        tap((user: Data) => {
          const selectedLanguage = user?.language_code ? user?.language_code : CommonVariable.preferredLanguage;
          this.languageCode = selectedLanguage;
          if (this.languageCode) this.loadSyndicatData();
        }),
        switchMap(() =>
          this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.pipe(
            catchError(() => of(null))
          ) ?? of(null)
        )
      ).subscribe({
        next: (data) => {
          if (!data) return;
          this.jackpotWidgetTranslatedData = data?.["jackpot-trigger-widget"];
          this.syndicatePageData = data?.["Syndicatepage"];
          this.luckyNumberWidget = data?.["lucky_number_widget"];
          this.goldRingWidget = data?.["gold_ring_widget"];
          this.extras = this.syndicatePageData?.extras;
          this.availableRemainingLn = this.luckyNumberWidget?.available_remaining_ln;
          this.noRemainingLn = this.luckyNumberWidget?.no_remaining_ln;
          this.highlightAvailableLn = this.luckyNumberWidget?.highlight_available_ln;
          this.highlightLnTitle = this.luckyNumberWidget?.highlight_ln_title;
          this.showBtn = this.luckyNumberWidget?.show_btn;
        },
        error: () => { }
      });
    } catch (e) {
      return e;
    }

    this.tabService?.selectSyndicateTab();
    this.widgetsFacade.getToolTipContent(this.languageCode);
    try {
      this.route.queryParams
        ?.pipe(
          takeUntil(this.unsubscribe$),

          tap((params: any) => {
            this.showWidgetToolTip =
              params?.highlighted === "lucky_number_tooltips";

            this.showGoldRingToolTip =
              params?.highlighted === "gold_rings";

            if (params?.trigger === "activated") {
              setTimeout(() => {
                this.authService
                  ?.getConstantsMsg("1047")
                  .then((translatedMsg) => {
                    const defaultMsg = {
                      message: {
                        line_1: "Trigger On! Control your trigger here",
                        line_2: "",
                      },
                      style: {
                        icon: "tick circle success.png",
                        type: "Success",
                      },
                    };

                    this.authService?.showToastMessage(
                      translatedMsg,
                      defaultMsg
                    );
                  })
                  .catch((err) => err);
              }, 5000);

              this.router.navigate(["mainTabs/tabs/syndicate"], {});
            }
          }),

          switchMap(() =>
            this.luckyNumberService
              ?.getShowWidgetsData()
              ?.pipe(catchError(() => of(null))) ?? of(null)
          )
        )
        .subscribe((ref: any) => {
          if (!ref) return;

          this.showWidgetsData = ref;

          if (this.showWidgetsData?.lucky_numbers === true) {
            this.closeExpandWidget();
            this.showMiniWidgets();
          } else {
            this.showMiniWidget = false;
          }

          if (this.showWidgetsData?.gold_rings === true) {
            this.closeGoldExpandWidget();
            this.showGoldRingsMiniWidget();
          } else {
            this.showGoldRingMiniWidget = false;
          }

          this.showPreviousCheck =
            this.showWidgetsData?.previous_check === true;
        });
    } catch (e) {
      return e;
    }
    // Jackpot triggers are now managed by the widgets facade
    // This method is to display couch and animation for previous check widget first time only
    try {
      this.syndicateService?.getOneTimeFeatures()?.subscribe((ref: any) => {
        if (ref?.previous_check_animation === true) this.syndicateRootService.showPreviousCheckAnimation.next(true);

        if (ref?.previous_widget_couch === true) this.showPreviousCheckCouch = true;
      });
    } catch (e) {
      return e;
    }

    try {
      this.luckyNumberService?.showAvailableLn?.subscribe((msg) => {
        if (msg) this.availableSyndicates();
      });
      this.luckyNumberService?.hideAvailableLn?.subscribe((res) => {
        if (res) this.closeExpandWidget();
      });
      this.luckyNumberService?.hideAvailableGR?.subscribe((res) => {
        if (res) {
          this.closeGoldExpandWidget();
          if (!this.showWidgetsData?.gold_rings) this.showGoldRingMiniWidget = false;
        }
      });
    } catch (e) {
      return e;
    }

    if (localStorage.getItem("datatoSyndi")) {
      this.syndicateUIHelper.loadEvent(this.syndicateDetails$, this.mixpanelService);
    }

    this.getAnimation();
    this.initUpdateAnimation();

    // Banner status is now managed by the widgets facade
  }
    getIconUrl(iconUrl: string | undefined): string {
        return this.notificationService.getIconUrl(iconUrl);
    }
  getAnimation() {
    const category = "syndicate";
    this.animationService
      .getAnimationBasedOnCategory(this.userId, category)
      .pipe(takeUntil(this.animationDestroy$))
      ?.subscribe((res: Data) => {
        if (!res) return;
        res?.forEach((item) => {
          if (!item) return;
          switch (item?.location_id) {
            case "first_syndicate_card_three_dots":
              this.firstSyndicateDotStatus = item?.status;
              this.firstSyndicateDotDuration = item?.duration;
              this.firstSyndicateDotOptions = {
                path: `../../../assets/${item?.lottie_animation_URL}`,
              };
              break;
            case "first_syndicate_card_view_tickets_cta":
              this.firstSyndicateCTAStatus = item?.status;
              this.firstSyndicateCTADuration = item?.duration;
              this.firstSyndicateCTAOptions = {
                path: `../../../assets/${item?.lottie_animation_URL}`,
              };
              break;
            case "see_previous_checks_link":
              this.previousCheckLinkStatus = item?.status;
              this.previousCheckLinkDuration = item?.duration;
              this.previousCheckLinkOptions = {
                path: `../../../assets/${item?.lottie_animation_URL}`,
              };
              break;
            case "lucky_numbers_widget":
              this.luckyNumberStatus = item?.status;
              this.luckyNumberDuration = item?.duration;
              this.luckyNumberOptions = {
                path: `../../../assets/${item?.lottie_animation_URL}`,
              };
              break;
            case "jackpot_triggers_widget":
              this.jackpotStatus = item?.status;
              this.jackpotDuration = item?.duration;
              this.jackpotOptions = {
                path: `../../../assets/${item?.lottie_animation_URL}`,
              };
              break;
          }
        });
      });
  }

  initUpdateAnimation() {
    this.updateAnimationSubject
      .pipe(
        concatMap(({ location_id, delayTime }) =>
          timer(delayTime * 1000).pipe(
            switchMap(() => this.sendUpdateStatusFB(location_id) ?? of(null))
          )
        ),
        takeUntil(this.animationDestroy$)
      )
      ?.subscribe();
  }

  // Dismiss the animation when user clicks on it.
  updateAnimationStatus(location_id: string, delayTime: number) {
    if (location_id && delayTime > 0 && delayTime != null) {
      this.updateAnimationSubject.next({ location_id, delayTime });
    }
  }

  onClick(location_id: string) {
    this.sendUpdateStatusFB(location_id)?.subscribe();
  }

  sendUpdateStatusFB(location_id: string): Observable<Data> {
    // Ensure userId is available, return empty Observable if not
    if (!this.userId) {
      return of(null);
    }

    // Check if any animation status is active
    const hasActiveAnimation = 
      this.firstSyndicateCTAStatus ||
      this.firstSyndicateDotStatus ||
      this.previousCheckLinkStatus ||
      this.luckyNumberStatus ||
      this.jackpotStatus;

    // If animation is active, call cloud function with error handling
    if (hasActiveAnimation) {
      return this.authService.getV2CloudFunction("updatemicroanimationv2", {
        userId: this.userId,
        locationIds: location_id,
        status: false,
      }).pipe(
        catchError((error) => {
          console.error('Error in sendUpdateStatusFB cloud function:', error);
          return of(null);
        })
      );
    }

    // Return empty Observable instead of undefined
    return of(null);
  }

  // This method is to open syndicate setting modal on click of each syndicate kebab menu
  async openSyndicateSetting(syndicate) {
    this.GTMSegment.HotJarEvent("click_syndicate_menu");
    this.updateProductForManagedSyndicate(syndicate);
    const syndicateSettings = await this.modalCtrl.create({
      component: SyndicateSettingComponent,
      cssClass: "modal-fullScreen",
      enterAnimation: this.cas.enterFromRight,
      leaveAnimation: this.cas.exitThroughRight,
      componentProps: {
        syndicate,
      },
    });
    return await syndicateSettings.present();
  }

  public pageScroller(pageTop: IonContent) {
    //scroll to page top
    if (!this.pageTop && pageTop) {
      this.pageTop = pageTop;
    } else if (!this.pageTop && !pageTop) {
      return;
    } else {
      this.pageTop?.scrollToTop();
    }
  }

  // This function is used to update the product details of the syndicate
  // This function takes the syndicate details as the input
  // This function returns syndicate details
  updateProductForManagedSyndicate(syndicateDetails: any) {
    try {
      if (!(syndicateDetails?.products?.length > 0)) {
        this.syndicateRootService
          .getSyndicateProduct(syndicateDetails?.encrypted_id)
          .pipe()
          ?.subscribe(
            (productDetails) => {
              this.syndicateLoaded?.forEach((managedSyndicate) => {
                if (managedSyndicate?.encrypted_id === syndicateDetails?.encrypted_id) {
                  managedSyndicate.products = productDetails;
                }
              });
            },
            (err) => {
              return err;
            }
          );
      }
    } catch (e) {
      return e;
    }
  }

  // This function is used to navigate user to check winnings page
  openCheckWinnings() {
    if (this.checkWinningsFlowService.isInFlight()) {
      return;
    }
    this.checkWinningsFlowService.startCheck({
      userId: this.userId,
      source: "syndicate_cta",
    });
    this.router.navigateByUrl("checkWinnings/checkWinningsSplash").catch(() => {
      this.checkWinningsFlowService.completeCheck({
        userId: this.userId,
        outcomeStatus: "cancelled",
        memberFacingMessage: "navigation_failed",
      });
    });
  }

  // this function is used for op syndicate tickets component on click of syndicate
  async openTickets(event: Data) {
    try {
      this.syndicateRootService.openTickets(event?.syndicate, event?.clickAction);
    } catch (error) {
      return error;
    }
  }

  // This method is used to get private syndicate ticket
  async getPrivateSyndicate(event: Data) {
    this.syndicateRootService.getPrivateSyndicate(event?.syndicate, event?.prdIndex);
  }

  // This method is to display list of checks bottom sheet
  openListOfChecks(previousChecks: any) {
    this.syndicateRootService.openListOfChecks(previousChecks);
    // this disable the animation when user clicks on prvious check link
    if (this.previousCheckLinkStatus) {
      this.updateAnimationStatus("see_previous_checks_link", this.previousCheckLinkDuration);
    }
  }

  // This method is to fetch more syndicates on scroll
  loadMoreSyndicates(event) {
    try {
      const startIndex = this.cardLimit;
      const addNextTenItems = startIndex + 5;

      if (startIndex >= this.syndicateCount) {
        this.infiniteScroll.disabled = true;
        this.showText = true;
        setTimeout(() => {
          this.showText = false;
        }, 3000);
      } else {
        setTimeout(() => {
          this.cardLimit = addNextTenItems;
          this.syndicateDataService.updateSyndicateRequest(addNextTenItems);
          event?.target.complete();
        }, 2000);
      }
    } catch (e) {
      return e;
    }
  }

  // Render url in html
  getUrl(url: string) {
    return "url('" + url + "')";
  }

  // Get syndicate card height for styling purpose
  getSyndicateCardHeight(productDetails: any) {
    this.syndicateRootService.getSyndicateCardHeight(productDetails);
  }

  // This method is used to show payment options modal
  async showPaymentOptions(syndicate: any) {
    this.syndicatePaymentService.showPaymentOptions(syndicate);
  }

  // This method is used show all syndicate members for the private syndicate
  openSyndicateMembers(syndicateMemberData: any) {
    try {
      const { sId, ps_name, inviteURL } = syndicateMemberData;
      this.syndicateService?.setSyndicateMembers({ psId: sId, psName: ps_name });
      this.syndicateDataService?.setSyndicateID(sId);
      this.syndicateDataService?.setSyndicateShareLink(inviteURL);
      this.router.navigate(["private-syndicate/syndicate-member/" + sId]);
    } catch (e) {
      return e;
    }
  }

  // Navigate to private syndicate page
  createSyndicate() {
    this.router.navigateByUrl("private-syndicate");
  }

  // Navigate to store page
  navigateToStore() {
    this.router.navigate(["/mainTabs/tabs/store"], {
      queryParams: { tip: "jackpot_trigger", ref: "trigger_widget" },
      fragment: "jackpot_trigger",
    });
  }

  // Open inbox message bottom sheet
  openMessage(message: Data) {
    if (!message) return;
    if (this.authService.templateNameArray.includes(message?.template_name)) {
      this.AuthPartialRegService.openAutoShowInbox(message);
    } else {
      const panelClass = this.orientationService.isFullscreen()
        ? "inbox-bottom-sheet-fullscreen"
        : message?.template_type === "plunko_christmas" || message?.template_type === "valentine_plunko_campaign"
          ? "bottom-sheet-fullscreen"
          : "inbox-bottom-sheet";
      this.bottomSheet.open(InboxMessageComponent, {
        panelClass: panelClass,
        data: message,
      });
    }
  }

  // Open chat
  openChat() {
    this.isChatClicked = true;
  }

  // Check user private syndicate status for the syndicate passed in parameter
  checkUserPsStatus(syndicate) {
    try {
      return this.syndicateService?.checkUserPsStatus(syndicate?.id).pipe(
        map((data: any) => {
          if (!data) return;
          let member: any = data?.find((x: any) => x?.user_id === this.userId);
          return member;
        })
      );
    } catch (e) {
      return e;
    }
  }

  // This method is used to chat with the private syndicate group peepso members
  chatNow(syndicate: any) {
    if (syndicate?.peepso_group_url && syndicate?.peepso_group_id != "null" && syndicate?.peepso_group_id != 0) {
      this.syndicateService?.updateNewMessageChat(syndicate?.sId);
      if (!Browser) {
        window.open(UtilityService.chatUrlFormation(syndicate));
        return;
      }
      this.lswTokenService?.openPepsoUrlView(syndicate);
    }
  }

  // Get product lines
  getPSLines(products) {
    let count = 0;
    if (products) {
      try {
        products?.map((product: any) => {
          count += product?.total_lines * product?.draw_day?.length;
        });
      } catch (e) {
        return e;
      }
    }

    return count;
  }

  // Get syndicate lines count
  getSyndicateLinesCount(products: any) {
    let count = 0;
    if (products) {
      products?.map((data) => {
        count += data?.total_lines;
      });
    }
    return count;
  }

  // Get syndicate product name
  getSyndicateProductName(products: any) {
    let productName: string = "";
    if (products) {
      products?.map((data) => {
        if (productName?.indexOf(data?.product_name) == -1) {
          if (productName == "") productName = productName + data?.product_name;
          else productName = productName + ", " + data?.product_name;
        }
        // productName = productName + data.product_name;
      });
    }
    return productName;
  }

  // This method is to redirect user to create syndicate
  routeToCreateSyndicate(syndicate) {
    try {
      syndicate["ticket_group"] = syndicate?.ticketDetails ? syndicate?.ticketDetails?.product_group : null;
      syndicate["lottery"] = this.lotteryData?.[0];
      syndicate["jackpot"] = this.lotteryData?.[1];
      let createPSJourneyData = {
        syndicate_name: syndicate?.ps_name,
        psId: syndicate?.sId,
        image_url: syndicate?.ps_image_url,
        type: syndicate?.type,
        title: syndicate?.ps_name,
        image: syndicate?.ps_image_url,
        cardType: syndicate?.type,
        product_group: this.syndicateRootService.getProducts(syndicate),
        page: "syndicate",
        ticketDetails: syndicate?.ticket_group,
      };
      this.syndicateDataService?.setSyndicateData(createPSJourneyData);
      this.router.navigate(["/private-syndicate/create-syndicate"], {});
    } catch (e) {
      return e;
    }
  }

  // This is a method that is called when a user touches the screen. This method sets the showToolTip$ observable to false, so that the tooltip will not be shown.
  touch() {
    this.showToolTip$.next(false);
  }

  // This function is used to track the syndicate id
  trackById(syndicate) {
    return syndicate?.sId;
  }

  // Show syndicate jackpot trigger popup
  showTriggerPopup(triggerData: any) {
    this.isToggled = false;
    this.callSwiper();
    const dialogRef = this.matDialog.open(SyndicateJackpotPopupComponent, {
      disableClose: true,
      panelClass: "jackpotWarning-size",
      hasBackdrop: true,
      backdropClass: "backdrop",
      data: triggerData,
    });
    try {
      dialogRef.afterClosed()?.subscribe(() => {
        this.isToggled = true;
        this.callSwiper();
      });
    } catch (e) {
      return e;
    }
  }

  // Open and display all jackpot trigger info
  opentriggerInfo(event) {
    event.stopPropagation();
    this.showJackpotExpandWidget = false;
    const dialogRef = this.matDialog.open(JackpotInfoPopupComponent, {
      panelClass: "jackpot-info-popup",
      hasBackdrop: true,
      backdropClass: "backdrop",
    });
  }

  getTimeFormate(synDate: string) {
    if (!synDate || typeof synDate !== "string") {
      return "N/A"; // Return a placeholder when date is missing
    }
    const dates = synDate?.replace("AM", "")?.replace("PM", "");
    // Parse the target date as a UTC date
    const targetDate = new Date(dates);
    // Get current time and convert it to UTC time
    const currentTime = new Date();
    const utcCurrentTime = new Date(currentTime.getTime() + currentTime.getTimezoneOffset() * 60000);
    // Calculate the difference in milliseconds
    let timeDifference = targetDate.getTime() - utcCurrentTime.getTime();
    // Ensure the difference is positive
    if (timeDifference > 0) {
      // Convert milliseconds difference to days
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      timeDifference -= days * (1000 * 60 * 60 * 24); // Remove the days from timeDifference
      // Convert the remaining milliseconds to hours
      const hours = Math.floor(timeDifference / (1000 * 60 * 60)) - 5;
      timeDifference -= hours * (1000 * 60 * 60); // Remove the hours from timeDifference
      // Return the result string
      const result = `${days}d ${hours}h`;
      return result;
    } else {
      return "Expired";
    }
  }

  // Get and decide syndicate pending status to display pending icon for the syndicate.

  replace(str: any): string {
    if (typeof str !== 'string') return '';
    return str.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
  }

  // to format date with specified format
  formatDatewithOrdinal(date: Data) {
    return moment(date).format("Do MMMM");
  }

  // This method is to set swiper instance to use in the page.
  setSwiperInstance(swiper: Swiper) {
    // Ensure swiper is fully initialized with params and autoplay module before assigning
    if (!swiper || !swiper.params || swiper.params.autoplay === undefined) {
      return;
    }

    this.swiperInstance = swiper;
    setTimeout(() => {
      this.interval = setInterval(() => {
        if (!swiper || !swiper.params) return;
        if (!this.showPreviousExpandWidget) return;
        if (swiper?.isEnd && this.autoplay) {
          swiper?.slideTo(0);
          return;
        }
        if (!this.autoplay) {
          return;
        }
        swiper?.slideNext(this.speed);
      }, this.setIntervalNumber);
    });
  }
  // This method is to set swiper instance to use in the page.
  setSwiperInstant(swiper: Swiper) {
    // Ensure swiper is fully initialized with params and autoplay module before assigning
    if (!swiper || !swiper.params || swiper.params.autoplay === undefined) {
      return;
    }

    this.slides = swiper;
    setTimeout(() => {
      this.intervals = setInterval(() => {
        if (!this.slides || !this.slides.params) return;
        if (this.slides.isEnd) {
          // this.slides.slideTo(0)
          return;
        }
        this.slides.slideNext(this.speed);
      }, this.time);
    }, this.time);
  }

  // this method is used to navigate to store page
  openToStorePage() {
    this.router.navigate(["/mainTabs/tabs/store"]);
  }

  // this method is used to replace the price currency node
  replacePlaceholder(originalString: string, currencySymbol: string, replacement: number | string): string {
    if (originalString == null) {
      // Handle null or undefined case
      return "";
    }
    return originalString?.replace("[currency_node:price]", `${currencySymbol}${replacement?.toString()}`);
  }
  // this method is used to navigate to checkout page
  goToCheckout(offerId: string) {
    this.router.navigate(["/mainTabs/tabs/store"], { queryParams: { payment: offerId } });
  }
  // This method has been used to get Syndicate payment status

  ionViewWillLeave(): void {
    this.syndicateService.userShownPurchaseStatus(this.syndicateID);
    this.userInboxSubscription?.unsubscribe();
  }


  // This method used to get tooltip data
  loadSyndicatData() {
    this.syndicateDataService
      ?.getTooltipVipStatus()
      ?.then((res: Data) => {
        // Only process if we got a valid response with data
        if (!res || !res?.data) {
          console.warn('[loadSyndicatData] Invalid tooltip response, skipping page offer update');
          return;
        }
        const syndicateOfferData = res?.data;
        const description = syndicateOfferData?.content?.[this.languageCode]?.description;
        if (description) {
          this.currencyConversion(description);
        }
        this.syndicatePageOffer$.next(syndicateOfferData);
      })
      .catch((err) => {
        // Silently handle Firebase permission errors to prevent RxJS stream issues
        console.warn('[loadSyndicatData] Error fetching page-offer data:', err?.message || err);
      });
  }
  // This method used to convert currency
  async currencyConversion(value: Data | string) {
    // Early return for invalid input to prevent async operations on null/undefined
    if (!value || typeof value !== "string") {
      return;
    }
    const startIndex = value.indexOf("[currency_beautify:");
    const endIndex = value.indexOf("]", startIndex);
    if (startIndex !== -1 && endIndex !== -1) {
      const currencySubstring = value.substring(startIndex, endIndex + 1);
      try {
        const currencyValue = await this.gameDatasService.getDVCurrency(currencySubstring);
        if (typeof currencyValue === "string") {
          const description = value?.replace(currencySubstring, currencyValue);
          this.lottryDescription$.next(description);
        }
      } catch (error) {
        console.warn('[currencyConversion] Error converting currency:', error?.message || error);
      }
    }
  }

  trackCTAClick(body?: Data) {
    const message = "quickPlay_clicked";
    this.GTMSegment?.GTMPopupInitialization(message, body);
  }

  NeedHelpMixPanel() {
    this.mixpanelService.init(this.userId);

    this.mixpanelService.track("Clicked syndicate help link", {
      current_url: window.location.href,
    });
  }
  handleCountdownFinish(): void {
    this.notificationsService.updateClaiminlineVoucherDismiss(this.inlineNotificationDetails?.notification_id?.path);
  }

  clickOfferBanner(syndicate: Data): void {
    this.syndicateUIHelper.clickOfferBanner(
      syndicate,
      this.storeDiscountDetails
    );
  }

  feedBackDismiss() {
    this.notificationService.feedBackDismiss();
  }

}
